import { Button } from "@/components/ui/button";
import { Star, XCircle, CheckCircle2, EyeOff, Download, Trash2, Wand2, X, Archive, ArchiveRestore, Undo2, Flame } from "lucide-react";

const btn = "h-8 text-xs bg-white/5 hover:bg-white/10 text-white";

function B({ onClick, testId, icon: Icon, children, cls = btn }) {
  return <Button size="sm" className={`shrink-0 ${cls}`} onClick={onClick} data-testid={testId}>{Icon && <Icon className="w-3.5 h-3.5 mr-1" />}{children}</Button>;
}

// Actions depend on the current view: normal photos, archived, or trash
export function SelectionBar({ count, view, onAction, onClear, onStudio, onZip, onPurge }) {
  if (!count) return null;
  const purge = <B onClick={onPurge} testId="bulk-purge" icon={Flame} cls="h-8 text-xs bg-red-600/20 hover:bg-red-600/30 text-red-400">Supprimer definitivement</B>;
  return (
    <div className="sticky top-[72px] z-[35] mb-4 flex flex-nowrap sm:flex-wrap overflow-x-auto items-center gap-1.5 bg-[#0B1120]/95 backdrop-blur border border-[#0099CC]/40 rounded-xl px-3 py-2 shadow-xl" data-testid="selection-bar">
      <span className="shrink-0 text-xs font-bold text-[#0099CC] mr-2" data-testid="selection-count">{count} selectionnee(s)</span>
      {view === "trash" ? (
        <><B onClick={() => onAction("restore")} testId="bulk-restore" icon={Undo2}>Restaurer</B>{purge}</>
      ) : view === "archived" ? (
        <><B onClick={() => onAction("unarchive")} testId="bulk-unarchive" icon={ArchiveRestore}>Restaurer</B>{purge}</>
      ) : (
        <>
          <B onClick={() => onAction("favorite")} testId="bulk-favorite" icon={Star}>Favori</B>
          <B onClick={() => onAction("reject")} testId="bulk-reject" icon={XCircle}>Rejeter</B>
          <B onClick={() => onAction("unreject")} testId="bulk-unreject">Retablir</B>
          <B onClick={() => onAction("publish")} testId="bulk-publish" icon={CheckCircle2} cls="h-8 text-xs bg-[#10B981]/15 hover:bg-[#10B981]/25 text-[#10B981]">Publier</B>
          <B onClick={() => onAction("unpublish")} testId="bulk-unpublish" icon={EyeOff}>Depublier</B>
          <B onClick={onStudio} testId="bulk-studio" icon={Wand2} cls="h-8 text-xs bg-[#F97316]/15 hover:bg-[#F97316]/25 text-[#F97316]">Traiter dans le Studio</B>
          <B onClick={onZip} testId="bulk-zip" icon={Download}>ZIP</B>
          <B onClick={() => onAction("archive")} testId="bulk-archive" icon={Archive}>Archiver</B>
          <B onClick={() => onAction("trash")} testId="bulk-trash" icon={Trash2} cls="h-8 text-xs bg-red-500/10 hover:bg-red-500/20 text-red-400">Retirer de la galerie</B>
          {purge}
        </>
      )}
      <button onClick={onClear} className="shrink-0 ml-auto text-[#64748B] hover:text-white" data-testid="selection-clear"><X className="w-4 h-4" /></button>
    </div>
  );
}
